module.exports = __webpack_public_path__ + "static/media/confirm.71915e7d.svg";